import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Stack from "@mui/material/Stack";
import { type ReactNode } from "react";

export interface BannerAlertProps {
  title: string;
  message: string;
  severity?: "error" | "warning" | "info" | "success";
  children?: ReactNode;
}

export function BannerAlert({
  title,
  message,
  severity = "error",
  children,
}: BannerAlertProps) {
  return (
    <Stack
      spacing={5}
      useFlexGap
      sx={{
        mb: 5,
        p: 3,
        backgroundColor: "primary._states.hover",
        borderRadius: 2,
      }}
    >
      <Alert severity={severity} variant="filled">
        <AlertTitle>{title}</AlertTitle>
        {message}
      </Alert>
      {children}
    </Stack>
  );
}
